import React from 'react';
import { connect } from 'redux-bundler-react';
import OpacitySlider from './opacity-slider';
import RemoveLayer from './remove-layer';
import LabelToggle from './label-toggle';
import LayerOrder from './layer-order';

class IdentifyDetails extends React.Component {
  render(){
    const { treeViewSelectedItem, doRenderTreeView } = this.props;
    let removeLayer =null;
    if(treeViewSelectedItem.type ==='LocalVector' && treeViewSelectedItem.dsName !=='IWRSS') {
      removeLayer =(<RemoveLayer layer={treeViewSelectedItem} />)
    }
    return (
      <div style={{marginTop:'6px', marginLeft:'6px'}}>
        <div style={{display:'inline-flex', alignItems:'baseline'}}>
          <span 
            onClick={ doRenderTreeView }
            style={{ position:'relative', fontSize:18, cursor:'pointer' }}
          >
            <i className="mdi mdi-arrow-left"></i>
          </span>
          <label className="control-label larger-font" style={{marginLeft:'6px'}}>{ treeViewSelectedItem.displayName }</label> 
        </div>
        <div className="thin-scrollbar sidebar-list" style={{ top: 32 }}>
          

          <OpacitySlider layer={treeViewSelectedItem.mapLayer} />

          <LabelToggle layer={treeViewSelectedItem} />
          <LayerOrder layer={treeViewSelectedItem} />  
          {removeLayer}

        </div>
      </div>
      
    )
  }
}

export default connect(
  'selectTreeViewSelectedItem',
  'doRenderTreeView',
  IdentifyDetails
)